import React, { FC } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { FormHelperText, FormControlLabel, FormControl } from '@mui/material'

import MUICustomCheckbox from './MUICustomCheckbox'

const useStyles = makeStyles()((theme: Theme) => ({
  customCheckboxWrapper: {
    marginBottom: theme.spacing(3),
  },

  formControl: {
    '& > span:last-child': {
      fontSize: '1rem',
      color: theme.palette.primary.dark,
    },
  },
}))

interface RFFCustomCheckboxProps extends FieldRenderProps<unknown> {
  className?: string
  fieldLabel?: React.ReactNode
}

const RFFCustomCheckbox: FC<RFFCustomCheckboxProps> = ({ input, meta, ...props }) => {
  const { classes, cx } = useStyles()

  return (
    <div className={cx(classes.customCheckboxWrapper, props.className)}>
      {/* //TODO: error check - error={true} */}
      <FormControl variant='standard'>
        <FormControlLabel
          control={
            //TODO: make it controllable component
            <MUICustomCheckbox
              // icon={<FavoriteBorder />}
              // checkedIcon={<Favorite />}
              name={input.name}
              onChange={input.onChange}
              checked={!!input.value} // To avoid warning from TS, checked should be boolean
            />
          }
          classes={{
            root: classes.formControl,
          }}
          label={props.fieldLabel}
        />
      </FormControl>
      <FormHelperText>{meta.error}</FormHelperText>
    </div>
  )
}

export default RFFCustomCheckbox
